/** The signed-in tutor, as the API echoes back from verified token claims. */
export interface UserModel {
  uid: string;
  email: string | null;
  name: string | null;
  emailVerified: boolean;
}

/** How the tutor gets paid. Reused in every payment reminder. */
export interface PaymentProfileModel {
  payboxLink: string | null;
  bitLink: string | null;
  bankName: string | null;
  bankBranch: string | null;
  bankAccount: string | null;
  bankOwner: string | null;
  /** Display only, used when the message or document is read in English. */
  bankNameEn: string | null;
  bankOwnerEn: string | null;
}

export const EMPTY_PAYMENT_PROFILE: PaymentProfileModel = Object.freeze({
  payboxLink: null,
  bitLink: null,
  bankName: null,
  bankBranch: null,
  bankAccount: null,
  bankOwner: null,
  bankNameEn: null,
  bankOwnerEn: null
});
